// 全局处理立即购买按钮（包括没有表单的情况）
document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    const buyNowButton = e.target.closest('[name="buy_now"]');
    if (!buyNowButton) return;
    
    const productForm = buyNowButton.closest('product-form');
    // 如果按钮在 product-form 内，由 product-form 处理
    if (productForm) return;
    
    // 处理没有表单的情况
    e.preventDefault();
    const quantityInput = buyNowButton.closest('.product__buy-buttons')?.querySelector('input[name="quantity"]');
    const variantId = buyNowButton.dataset.variantId;
    
    if (!variantId) {
      console.error('无法找到商品变体ID');
      return;
    }
    
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    
    if (buyNowButton.getAttribute('aria-disabled') === 'true' || buyNowButton.disabled) return;
    
    buyNowButton.setAttribute('aria-disabled', true);
    buyNowButton.classList.add('loading');
    
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    config.body = formData;
    
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error('添加商品失败:', response.description);
          return;
        }
        // 立即跳转到结账页面
        window.location.href = navigationRepack('/checkout');
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        buyNowButton.classList.remove('loading');
        buyNowButton.removeAttribute('aria-disabled');
      });
  });
});

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (this.form) {
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.buyNowButton = this.querySelector('[name="buy_now"]');
      if (this.buyNowButton) {
        this.buyNowButton.addEventListener('click', this.onBuyNowHandler.bind(this));
      }

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    onBuyNowHandler(evt) {
      evt.preventDefault();
      evt.stopPropagation(); // 阻止事件冒泡到全局处理器
      if (this.buyNowButton.getAttribute('aria-disabled') === 'true' || this.buyNowButton.disabled) return;

      this.handleErrorMessage();

      this.buyNowButton.setAttribute('aria-disabled', true);
      this.buyNowButton.classList.add('loading');
      const spinner = this.buyNowButton.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            this.error = true;
            return;
          }

          // 立即跳转到结账页面
          window.location.href = navigationRepack('/checkout');
        })
        .catch((e) => {
          console.error(e);
          this.handleErrorMessage('添加商品时出错，请重试');
        })
        .finally(() => {
          this.buyNowButton.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
          if (!this.error) this.buyNowButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
